
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate-old",
      function () {
        return require("private-next-pages/affiliate-old.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate-old"])
      });
    }
  